import api from './api';

export interface FuncionalidadeDTO {
  id: number;
  chave: string;
  descricao: string;
  categoria: 'SAUDE' | 'EDUCACAO';
  percentual?: number;
  ativo: boolean;
}

const base = '/admin/funcionalidades';

const listAll = () => api.get<FuncionalidadeDTO[]>(base);
const listAtivas = () => api.get<FuncionalidadeDTO[]>('/camara/funcionalidades/ativas').then(r => r.data);
const create = (payload: any) => api.post(base, payload);
const update = (id: number, payload: any) => api.put(`${base}/${id}`, payload);
const remove = (id: number) => api.delete(`${base}/${id}`);

export default { listAll, listAtivas, create, update, remove };
